import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { Body2 } from '../../../../../../atomic/text/Text';
import style from './TopRowPctQtySwitch.module.css';

export const TopRowPctQtySwitch = ({
  backgroundColor,
  width,
  justifyContent,
  type,
  setType,
}) => {

  return (
    <div
      className={style.box}
      style={{ backgroundColor, width, justifyContent }}
    >
      <div
        onClick={() => {
          if (type === 'pct') return;
          else setType('pct');
        }}
        className={type === 'pct' ? style.selected : style.notSelected}
      >
        <Body2 color={colors.lightGrey} fontWeight={700}>
          Pct.
        </Body2>
      </div>
      <div
        onClick={() => {
          if (type === 'qty') return;
          else setType('qty');
        }}
        className={type === 'qty' ? style.selected : style.notSelected}
      >
        <Body2 color={colors.lightGrey} fontWeight={700}>
          Qty.
        </Body2>
      </div>
    </div>
  );
};

TopRowPctQtySwitch.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.string,
  color: PropTypes.string,
  justifyContent: PropTypes.string,
  setQty: PropTypes.func,
  setType: PropTypes.func,
  type: PropTypes.string,
  width: PropTypes.string
};

